import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SubscriptionPlanDescription = function SubscriptionPlanDescription(_ref) {
  var _classNames;

  var description = _ref.description,
      numberOfLines = _ref.numberOfLines,
      onLearnMoreClick = _ref.onLearnMoreClick,
      _ref$showFullText = _ref.showFullText,
      showFullText = _ref$showFullText === void 0 ? false : _ref$showFullText,
      isPreview = _ref.isPreview;
  var serviceDescriptionRef = useRef(null);

  var _useState = useState(!showFullText),
      showReadMore = _useState[0],
      setReadMore = _useState[1];

  useEffect(function () {
    var _serviceDescriptionRe = serviceDescriptionRef === null || serviceDescriptionRef === void 0 ? void 0 : serviceDescriptionRef.current,
        scrollHeight = _serviceDescriptionRe.scrollHeight;

    var _serviceDescriptionRe2 = serviceDescriptionRef === null || serviceDescriptionRef === void 0 ? void 0 : serviceDescriptionRef.current,
        offsetHeight = _serviceDescriptionRe2.offsetHeight;

    if (offsetHeight < scrollHeight) {
      // element has an overflow
      // show read more button
      setReadMore(true);
    } else {
      // element doesn't have overflow
      setReadMore(false);
    }
  }, []);
  var lineClamp = "line-clamp-".concat(numberOfLines);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: classNames('leading-6 mb-2 text-base', (_classNames = {}, _defineProperty(_classNames, lineClamp, showReadMore), _defineProperty(_classNames, 'line-clamp-none', !showReadMore), _defineProperty(_classNames, 'text-gray-500', isPreview), _classNames)),
      ref: serviceDescriptionRef,
      children: description
    }), /*#__PURE__*/_jsx("div", {
      children: showReadMore && /*#__PURE__*/_jsx("a", {
        className: "clickable fw-500 text-subkit-primary mt-3",
        onClick: onLearnMoreClick,
        children: "Learn more"
      })
    })]
  });
};